import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import privateResume from "/pdfs/AriGoldman.pdf";
import publicResume from "/pdfs/Goobst.pdf";
import { useDomain } from "../helpers/DomainContext";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function Resume() {
    const { showPersonalInfo } = useDomain();

    const containerRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState<number>(800);

    useEffect(() => {
        function updateWidth() {
            if (containerRef.current) {
                setWidth(containerRef.current.clientWidth);
            }
        }

        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <div
                    ref={containerRef}
                    style={{ width: "100%", border: "0.5rem double white" }}
                >
                    <Document
                        file={showPersonalInfo ? privateResume : publicResume}
                    >
                        <Page pageNumber={1} width={width} />
                    </Document>
                </div>
                <a download={showPersonalInfo ? privateResume : publicResume}>
                    <button>Download Resume ↓</button>
                </a>
            </div>
        </>
    );
}
